/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Server_Reminder_TitleInputs */

const en_us2_push_server_reminder_title = /** @type {(inputs: Push_Server_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time to train`)
};

const pt_br2_push_server_reminder_title = /** @type {(inputs: Push_Server_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de treinar`)
};

const es_419_push_server_reminder_title = /** @type {(inputs: Push_Server_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de entrenar`)
};

const pt_pt2_push_server_reminder_title = /** @type {(inputs: Push_Server_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de treinar`)
};

const fr_fr2_push_server_reminder_title = /** @type {(inputs: Push_Server_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est l'heure de s'entraîner`)
};

const de_de2_push_server_reminder_title = /** @type {(inputs: Push_Server_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit zu trainieren`)
};

const it_it2_push_server_reminder_title = /** @type {(inputs: Push_Server_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È ora di allenarsi`)
};

/**
* | output |
* | --- |
* | "Time to train" |
*
* @param {Push_Server_Reminder_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_server_reminder_title = /** @type {((inputs?: Push_Server_Reminder_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Server_Reminder_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_server_reminder_title(inputs)
	if (locale === "es-419") return es_419_push_server_reminder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_push_server_reminder_title(inputs)
	if (locale === "fr-FR") return fr_fr2_push_server_reminder_title(inputs)
	if (locale === "de-DE") return de_de2_push_server_reminder_title(inputs)
	if (locale === "it-IT") return it_it2_push_server_reminder_title(inputs)
	return en_us2_push_server_reminder_title(inputs)
});
export { push_server_reminder_title as "push-server.reminder_title" }